'use client'

import React from 'react'

import { useTranslation } from '@/hooks/useDebugTranslations'

type TClientProps = { text: string }

export const TClient: React.FC<TClientProps> = ({ text }) => {
  const { t } = useTranslation()
  return <>{t(text)}</>
}
